///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, OnInit, AfterViewInit, OnDestroy, Injector } from '@angular/core';

@Component({
    selector: 'kb-unauthorized-page',
    templateUrl: './unauthorized-page.view.component.html',
    styleUrls: ['./unauthorized-page.view.component.css'],
})
export class UnauthorizedPageViewBaseComponent implements OnInit, AfterViewInit, OnDestroy {
    constructor(public injector: Injector) {}

    public ngOnInit(): void {
        this['onInit']();
    }

    public ngAfterViewInit(): void {
        this['onShow']();
    }

    public ngOnDestroy(): void {
        this['onHide']();
    }
}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/modules/application/unauthorized-page/unauthorized-page.view.base.component.ts